import { Html as HtmlDrei, type HtmlProps } from '@react-three/drei/web/Html';
import { forwardRef, memo, useRef, type MutableRefObject, type ReactNode, useImperativeHandle } from 'react';

interface Props extends HtmlProps {
  children: ReactNode;
}

// Used to insert HTML content into Three scene
export const Html = memo(
  forwardRef<HTMLDivElement, Props>(({ children, ...rest }, forwardedRef) => {
    const container = useRef() as MutableRefObject<HTMLElement>;
    container.current ||= document.querySelector('main')!;

    const localRef = useRef<HTMLDivElement | null>(null);
    // merge localRef together with forwardedRef
    useImperativeHandle(forwardedRef, () => localRef.current!);

    return (
      <HtmlDrei {...rest} portal={container} ref={localRef}>
        {children}
      </HtmlDrei>
    );
  })
);
